if (!customElements.get('wlsn-announcement-bar')) {
  class WLSNAnnouncementBar extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        active: 'active',
        hidden: 'wlsn-hidden',
        swiperClass: 'js-announcement-bar-slider',
        prevButton: 'js-swiper-btn-prev',
        nextButton: 'js-swiper-btn-next',
        sectionId: `${this.getAttribute('data-section-id')}`,
      };

      this.lastScroll = window.scrollY;
    }
    
    /**
     * Get DOM elements
     * @returns {object} - Object containing DOM element references
     */
    get elements() {
      return {
        swiperElement: this.querySelector(`.${this.classes.swiperClass}`),
        prevButton: this.querySelector(`.${this.classes.prevButton}`),
        nextButton: this.querySelector(`.${this.classes.nextButton}`),
      };
    }

    /**
     * Connected callback lifecycle method
     * @returns {void}
     */
    connectedCallback() {
      this._initializeSwiper();
      this._setAnnouncementBarHeight();
      window.matchMedia('(max-width: 1023px)').addEventListener('change', this._setAnnouncementBarHeight.bind(this));
      window.addEventListener('scroll', this._handleScroll.bind(this));
    }

    /**
     * Disconnected callback lifecycle method
     * @returns {void}
     */
    disconnectedCallback() {
      window.removeEventListener('scroll', this._handleScroll);
    }

    /**
     * Initialize Swiper carousel
     * @returns {void}
     */
    _initializeSwiper() {
      const settingsElement = document.getElementById(`CarouselSettings-${this.classes.sectionId}`);
      const settings = JSON.parse(settingsElement.textContent);

      this.swiper = new Swiper(this.elements.swiperElement, {
        loop: settings.loop,
        spaceBetween: 12,
        slidesPerView: 1,
        pagination: false,
        autoplay: {
          delay: settings.animationSpeed || 3000,
          enabled: settings.autoplay,
        },

        navigation: {
          prevEl: this.elements.prevButton,
          nextEl: this.elements.nextButton,
          enabled: true,
        },
      });

      if (!this.swiper.isLocked) {
        this.elements.prevButton?.classList.remove(this.classes.hidden);
        this.elements.nextButton?.classList.remove(this.classes.hidden);
      } else {
        this.elements.prevButton?.classList.add(this.classes.hidden);
        this.elements.nextButton?.classList.add(this.classes.hidden);
      }
    }

    /**
     * Handle scroll event to update announcement bar height
     * @returns {void}
     */
    _handleScroll() {
      const currentScroll = window.scrollY;
      const announcementBarHeight = currentScroll > this.offsetHeight ? 0 : this.offsetHeight;
      document.documentElement.style.setProperty('--wlsn-announcement-bar-height', `${announcementBarHeight}px`);
      this.lastScroll = currentScroll;
    }

    /**
     * Set announcement bar height CSS variable
     * @returns {void}
     */
    _setAnnouncementBarHeight() {
      const announcementBarHeight = this.offsetHeight;
      document.documentElement.style.setProperty('--wlsn-announcement-bar-height', `${announcementBarHeight}px`);
    }
  }

  window.customElements.define('wlsn-announcement-bar', WLSNAnnouncementBar);
}
